import bgImage from "assets/img/imagem_cordilheira.svg";
import nuvens from "assets/img/nuvens.svg";

const pagesStyle = theme => ({
  wrapper: {
    height: "auto",
    minHeight: "100vh",
    position: "relative",
    top: "0"
  },
  fullPage: {
    padding: "120px 0",
    position: "relative",
    minHeight: "100vh",
    maxHeight: "1000px",
    display: "flex!important",
    margin: "0",
    border: "0",
    color: "#fff",
    alignItems: "center",
    backgroundSize: "auto 65%, contain",
    backgroundPosition: "bottom -100px right 100px, 0",
    backgroundRepeat: "no-repeat",
    backgroundImage: "url(" + bgImage + "), linear-gradient(0deg, rgba(140,207,230,1) 0%, rgba(217,238,245,1) 100%)",
    height: "100%",
    "& footer": {
      position: "absolute",
      bottom: "0",
      width: "100%",
      border: "none !important"
    },
    /*"&:before": {
          backgroundColor: "rgba(0, 0, 0, 0.65)"
        },*/
    "&:before": {
      display: "block",
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
      "-webkit-animation": "slide-vertical 6s ease-in-out infinite alternate both",
      animation: "slide-vertical 6s ease-in-out infinite alternate both",
      backgroundSize: "100% auto",
      backgroundPosition: "top",
      backgroundRepeat: "no-repeat",
      backgroundImage: "url(" + nuvens + ")",
    }
  }
});

export default pagesStyle;
